import {useParams} from "react-router";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize as crs, flex, p} from "@pg-design/helpers-css";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {rankingLastYear} from "../../constants/ranking";
import {ISearchedRegion} from "../../types/ISearchedRegion";

interface IProps {
    handleGetMoreInfoClick: () => void;
    region: ISearchedRegion;
    className?: string;
}

export function OfferRankingBanner(props: IProps) {
    const {handleGetMoreInfoClick, region} = props;
    const params = useParams<IRankingAnnualParams>();
    const theme = useTheme();
    const rankingYear = params.year ? params.year : rankingLastYear;

    return (
        <div css={offerRankingBanner}>
            <BrandCrownIcon size="8" wrapperColor={theme.colors.primary} wrapperSize="8" />

            <div css={content}>
                <Text as="h1" variant="headline_3" fontFamily="secondary" align="center">
                    Ranking inwestycji {region.name_declension_where}
                </Text>

                <Text variant="body_copy_1" css={bannerText}>
                    Odkryj, które inwestycje {region.name_declension_where} cieszyły się największym zainteresowaniem setek tysięcy naszych użytkowników w{" "}
                    {rankingYear} roku i znajdź swoje wymarzone M.
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
}

const offerRankingBanner = (theme: Theme) => css`
    background-color: ${theme.colors.success};
    ${borderRadius(2)};
    ${p(4)};
    ${flex("center")};
    flex-direction: column;
    gap: ${crs(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
        align-items: flex-start;
    }
`;

const bannerText = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;

const content = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${crs(2)};
    align-items: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        align-items: flex-start;
    }
`;
import {useParams} from "react-router";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize as crs, flex, p} from "@pg-design/helpers-css";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {rankingLastYear} from "../../constants/ranking";
import {ISearchedRegion} from "../../types/ISearchedRegion";

interface IProps {
    handleGetMoreInfoClick: () => void;
    region: ISearchedRegion;
    className?: string;
}

export function OfferRankingBanner(props: IProps) {
    const {handleGetMoreInfoClick, region} = props;
    const params = useParams<IRankingAnnualParams>();
    const theme = useTheme();
    const rankingYear = params.year ? params.year : rankingLastYear;

    return (
        <div css={offerRankingBanner}>
            <BrandCrownIcon size="8" wrapperColor={theme.colors.primary} wrapperSize="8" />

            <div css={content}>
                <Text as="h1" variant="headline_3" fontFamily="secondary" align="center">
                    Ranking inwestycji {region.name_declension_where}
                </Text>

                <Text variant="body_copy_1" css={bannerText}>
                    Odkryj, które inwestycje {region.name_declension_where} cieszyły się największym zainteresowaniem setek tysięcy naszych użytkowników w{" "}
                    {rankingYear} roku i znajdź swoje wymarzone M.
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
}

const offerRankingBanner = (theme: Theme) => css`
    background-color: ${theme.colors.success};
    ${borderRadius(2)};
    ${p(4)};
    ${flex("center")};
    flex-direction: column;
    gap: ${crs(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
        align-items: flex-start;
    }
`;

const bannerText = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;

const content = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${crs(2)};
    align-items: center;

    @media (min-width: ${theme.breakpoints.sm}) {
        align-items: flex-start;
    }
`;
